// extracted by mini-css-extract-plugin
export var growableInput = "_ag-0";
export var tagContainer = "_ag-2";
export var textInput = "_ag-1";